import { BoxOfferInvitationLink } from "@modules/boxOffer/entities/boxOfferTypes"
import { MemberDetailsInfo } from "@modules/members/components/memberDetailsInfo"
import { MemberOfferInvitation } from "@modules/members/memberOffers/components/memberOfferInvitation"
import { useSidebar } from "@modules/sidebar/hooks/useSidebar"
import { SidebarNavigatorParams } from "@modules/sidebar/sidebarTypes"

export const useMemberSideBar = () => {
  const { sidebarNavigateTo } = useSidebar()

  const navigateToMemberDetailsInfo = (memberId: string, args: SidebarNavigatorParams) => {
    sidebarNavigateTo({
      content: <MemberDetailsInfo memberId={memberId} />,
      ...args,
    })
  }

  const navigateToMemberOfferInvitation = (
    boxOfferInvitationLink: BoxOfferInvitationLink,
    args?: SidebarNavigatorParams,
  ) => {
    sidebarNavigateTo({
      content: <MemberOfferInvitation boxOfferInvitationLink={boxOfferInvitationLink} />,
      ...args,
    })
  }

  return { navigateToMemberOfferInvitation, navigateToMemberDetailsInfo }
}
